import { render, staticRenderFns } from "./flash.vue?vue&type=template&id=308f6d1d&scoped=true"
import script from "./flash.vue?vue&type=script&lang=js"
export * from "./flash.vue?vue&type=script&lang=js"
import style0 from "./flash.vue?vue&type=style&index=0&id=308f6d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f6d1d",
  null
  
)

export default component.exports